<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Tags
        <small>List of tags</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">Tags</li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <strong>Filter Tags</strong>
          <div class="box-tools pull-right">
            <button type="button"
              class="btn btn-box-tool"
              data-widget="collapse">
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="box-body" style="overflow: inherit">
          <div class="form-group">
            <label for="promoPaymentName">
              Name
            </label>

            <input type="text"
              class="form-control"
              id="tagName"
              placeholder="Search by name here"
              v-model="params.name"
              @keyup="onInput">
          </div>
        </div>
      </div>

      <div class="box">
        <div class="box-header">
          <a class="btn btn-success pull-right"
            @click.prevent="add">
            Add New Tag
          </a>
        </div>

        <div class="box-body">
          <table id="table" class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Slug</th>
                <th>Action(s)</th>
              </tr>
            </thead>

            <tbody v-if="isLoading" key="loading">
              <tr>
                <td colspan="3">
                  <h3>Loading</h3>
                </td>
              </tr>
            </tbody>

            <tbody v-else-if="!isLoading && items.length < 1" key="empty">
              <tr>
                <td colspan="3">
                  <strong>Result not found</strong>
                </td>
              </tr>
            </tbody>

            <tbody v-else key="data">
              <tr v-for="item in items">
                <td>{{ item.name }}</td>
                <td>{{ item.slug }}</td>
                <td>
                  <a class="btn btn-primary btn-xs" @click.prevent="edit(item.id)">Edit</a>
                  <a class="btn btn-danger btn-xs" @click.prevent="remove(item)">Delete</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="box-footer">
          <Pagination
            :pagination="pagination"
            @goto-page="changePage" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import Common from '@/mixins/Common';
import Pagination from '@/components/modules/common/Pagination';

export default {
  name: 'TagIndex',

  mixins: [Common],

  components: {
    Pagination,
  },

  data() {
    return {
      isLoading: true,
      items: [],
      pagination: {},
      params: {
        page: null,
        name: null,
      },
    };
  },

  methods: {
    async init() {
      await this.setQuery();
      await this.fetch();
      this.isInitial = false;
    },

    fetch(page) {
      this.isLoading = true;
      this.params.page = page || null;

      this.axios.get('/tags', { params: this.params })
        .then((response) => {
          const { data, meta } = response.data;

          const isEmpty = (!data && (meta.pagination.current_page > meta.pagination.total_pages));
          this.items = (!isEmpty) ? data : [];
          this.pagination = (!isEmpty) ? meta.pagination : {};
          this.isLoading = false;
          this.setPushState();
        });
    },

    onInput: debounce(function debouncedInput() {
      this.fetch();
    }, 500),

    setQuery() {
      return new Promise((resolve) => {
        this.params.name = this.$route.query.name || null;
        this.params.page = (this.$route.query.page) ? this.$route.query.page : null;

        resolve();
      });
    },

    setPushState() {
      const title = `Tags page ${this.params.page}`;
      const paramUrl = '/tags';
      const parameters = this.generateQuery(this.params);
      window.history.pushState(title, null, `${paramUrl}${parameters}`);
    },

    generateQuery(params) {
      if (!params) return null;

      const query = Object.keys(params)
        .filter(key => (params[key]))
        .map(key => `${key}=${this.params[key]}`);

      return (query) ? `?${query.join('&')}` : null;
    },

    changePage(page) {
      this.fetch(page);
    },

    add() {
      this.$router.push({
        name: 'tag-create',
      });
    },

    edit(id) {
      this.$router.push({
        name: 'tag-edit',
        params: {
          id,
        },
      });
    },

    delete(tag) {
      this.axios.delete(`/tags/${tag.id}`)
        .then(() => {
          this.fetch();

          this.$swal(
            'Deleted!',
            `${tag.name} has been deleted.`,
            'success',
          );
        });
    },

    remove(tag) {
      this.$swal({
        title: 'Deleting Tag',
        text: `Are you sure you want to delete ${tag.name}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      })
      .then((result) => {
        if (result.value) {
          this.delete(tag);
        } else {
          this.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000,
          });
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          this.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000,
          });
        }
      });
    },
  },

  created() {
    this.init();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/tags/Index.vue